import { render, staticRenderFns } from "./ReferenceModal.vue?vue&type=template&id=97c01c38&scoped=true&"
import script from "./ReferenceModal.vue?vue&type=script&lang=js&"
export * from "./ReferenceModal.vue?vue&type=script&lang=js&"
import style0 from "./ReferenceModal.vue?vue&type=style&index=0&id=97c01c38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97c01c38",
  null
  
)

export default component.exports